import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo, useState } from "react";
import { useFulfillmentGroupPermissions } from "../../utils/use-assigned-fulfillment-service";

function formatter(kind: "internalNote" | "noteToBuyer" | "noteFromBuyer") {
  if (kind === "internalNote") {
    return "Internal note";
  }
  if (kind === "noteToBuyer") {
    return "Note to buyer";
  }
  return "Order Notes";
}

export const NoteCell = memo(function NoteCell({
  row,
  kind,
  handleUpdates,
}: {
  row: FulfillmentGroupData;
  kind: "internalNote" | "noteToBuyer" | "noteFromBuyer";
  handleUpdates: (updates: FulfillmentGroupUpdate[]) => void;
}) {
  const [isBeingEdited, setIsBeingEdited] = useState(false);
  const [editingNoteText, setEditingNoteText] = useState("");

  const { permissionsToEditEveryGroup } = useFulfillmentGroupPermissions([row]);

  const isEditable = useMemo(() => {
    if (kind === "noteFromBuyer") {
      return false;
    }
    return permissionsToEditEveryGroup;
  }, [permissionsToEditEveryGroup, kind]);

  const title = formatter(kind);
  const displayText = row[kind] ?? "";

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <RedoModal
        isOpen={isBeingEdited}
        modalSize="sm"
        onModalCloseRequested={() => setIsBeingEdited(false)}
        primaryButton={{
          text: "Save",
          size: "sm",
          onClick: () => {
            handleUpdates([
              { fulfillmentGroupId: row._id, [kind]: editingNoteText },
            ]);
            setIsBeingEdited(false);
          },
        }}
        secondaryButton={{
          text: "Cancel",
          onClick: () => setIsBeingEdited(false),
          size: "sm",
        }}
        title={`Edit ${title.toLowerCase()}`}
      >
        <RedoTextareaInputField
          label={title}
          placeholder={`Enter ${title.toLowerCase()}...`}
          setValue={setEditingNoteText}
          value={editingNoteText}
        />
      </RedoModal>
      <Flex
        onClick={(e) => {
          if (isEditable) {
            setEditingNoteText(displayText);
            setIsBeingEdited(true);
          }
          e.stopPropagation();
        }}
      >
        <RedoTableTextCell text={displayText} />
      </Flex>
    </div>
  );
});
